import { Search, User, Heart, ShoppingCart } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useLanguage } from "@/contexts/LanguageContext";
import { useWishlist } from "@/contexts/WishlistContext";
import { useCart } from "@/contexts/CartContext";
import SearchModal from "./SearchModal";
import Cart from "./Cart";
import Wishlist from "./Wishlist";
import { useState } from "react";

const MobileBottomNav = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { t } = useLanguage();
  const { items: wishlistItems } = useWishlist();
  const { items: cartItems, getTotalItems } = useCart();

  const wishlistCount = wishlistItems.length;
  const cartCount = getTotalItems();

  return (
    <>
      <nav className="lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-background border-t border-border/50 shadow-[0_-2px_10px_rgba(0,0,0,0.1)]">
        <div className="flex items-center justify-around h-16 px-4 max-w-screen-sm mx-auto">
          {/* Search */}
          <SearchModal>
            <Button
              variant="ghost"
              size="icon"
              className="flex-col h-auto py-2 px-6 gap-1.5 hover:bg-accent/60 active:scale-95 transition-all duration-200 rounded-xl min-w-[72px]"
              aria-label={t.header.search}
            >
              <Search size={22} className="text-foreground/80" strokeWidth={2} />
              <span className="text-[10px] font-medium text-foreground/70">{t.header.search}</span>
            </Button>
          </SearchModal>

          {/* Account */}
          <Button
            variant="ghost"
            size="icon"
            className="flex-col h-auto py-2 px-6 gap-1.5 hover:bg-accent/60 active:scale-95 transition-all duration-200 rounded-xl min-w-[72px]"
            onClick={() => navigate(user ? "/account" : "/auth")}
            aria-label={user ? t.header.myAccount : t.header.login}
          >
            <User size={22} className="text-foreground/80" strokeWidth={2} />
            <span className="text-[10px] font-medium text-foreground/70">{user ? t.header.account : t.header.login}</span>
          </Button>

          {/* Wishlist */}
          <Wishlist mobileNav />

          {/* Cart */}
          <Cart mobileNav />
        </div>
      </nav>
    </>
  );
};

export default MobileBottomNav;
